
<template>
  <!-- HERO DE SERVICIOS MODIFICADO -->
  <div class="services-hero">
    <div class="hero-content">
      <div class="col-md-8 mx-auto text-center">
        <h1 class="display-3 fw-bold hero-title animate-title">
          Nuestros Servicios
        </h1>
        <h3 class="fw-normal hero-subtitle mb-4 animate-subtitle">
          Soluciones tecnológicas para impulsar tu negocio
        </h3>
        <p class="lead animate-subtitle">
          Cada servicio está diseñado para adaptarse a las necesidades
          específicas de tu empresa
        </p>
      </div>
    </div>
    <!-- NUEVO DISEÑO VISUAL - CÍRCULOS FLOTANTES -->
    <div class="floating-circles">
      <div class="circle circle-1 animate-float-1"></div>
      <div class="circle circle-2 animate-float-2"></div>
      <div class="circle circle-3 animate-float-3"></div>
      <div class="circle circle-4 animate-float-4"></div>
    </div>
  </div>

  <!-- SECCIÓN PRINCIPAL DE SERVICIOS -->
  <section class="all-services-section">
    <div class="container">
      <h2 class="section-title text-center mb-5">Todos Nuestros Servicios</h2>

      <!-- GRID 2x2 EN DESKTOP / CARRUSEL EN MÓVIL -->
      <div class="services-main-container">
        <!-- DESKTOP: Grid 2x2 -->
        <div class="services-grid-desktop">
          <div
            v-for="service in services"
            :key="service.id"
            class="service-horizontal-card"
            :class="{ active: activeService === service.id }"
            @click="setActiveService(service.id)"
          >
            <div class="horizontal-card-content">
              <div class="horizontal-icon">
                <svg v-if="service.iconType === 'code'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0"/>
                </svg>
                <svg v-else-if="service.iconType === 'window'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1zM1 13V6h4v8H2a1 1 0 0 1-1-1m5 1V6h9v7a1 1 0 0 1-1 1z"/>
                </svg>
                <svg v-else-if="service.iconType === 'database'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313M13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A5 5 0 0 0 13 5.698M14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A5 5 0 0 0 13 8.698m0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525"/>
                </svg>
                <svg v-else-if="service.iconType === 'ai'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M14.949 6.547a3.94 3.94 0 0 0-.348-3.273 4.11 4.11 0 0 0-4.4-1.934A4.1 4.1 0 0 0 8.423.2 4.15 4.15 0 0 0 6.305.086a4.1 4.1 0 0 0-1.891.948 4.04 4.04 0 0 0-1.158 1.753 4.1 4.1 0 0 0-1.563.679A4 4 0 0 0 .554 4.72a3.99 3.99 0 0 0 .502 4.731 3.94 3.94 0 0 0 .346 3.274 4.11 4.11 0 0 0 4.402 1.933c.382.425.852.764 1.377.995.526.231 1.095.35 1.67.346 1.78.002 3.358-1.132 3.901-2.804a4.1 4.1 0 0 0 1.563-.68 4 4 0 0 0 1.14-1.253 3.99 3.99 0 0 0-.506-4.716m-6.097 8.406a3.05 3.05 0 0 1-1.945-.694l.096-.054 3.23-1.838a.53.53 0 0 0 .265-.455v-4.49l1.366.778q.02.011.025.035v3.722c-.003 1.653-1.361 2.992-3.037 2.996m-6.53-2.75a2.95 2.95 0 0 1-.36-2.01l.095.057L5.29 12.09a.53.53 0 0 0 .527 0l3.949-2.246v1.555a.05.05 0 0 1-.022.041L6.473 13.3c-1.454.826-3.311.335-4.15-1.098m-.85-6.94A3.02 3.02 0 0 1 3.07 3.949v3.785a.51.51 0 0 0 .262.451l3.93 2.237-1.366.779a.05.05 0 0 1-.048 0L2.585 9.342a2.98 2.98 0 0 1-1.113-4.094zm11.216 2.571L8.747 5.576l1.362-.776a.05.05 0 0 1 .048 0l3.265 1.86a3 3 0 0 1 1.173 1.207 2.96 2.96 0 0 1-.27 3.2 3.05 3.05 0 0 1-1.36.997V8.279a.52.52 0 0 0-.276-.445m1.36-2.015-.097-.057-3.226-1.855a.53.53 0 0 0-.53 0L6.249 6.153V4.598a.04.04 0 0 1 .019-.04L9.533 2.7a3.07 3.07 0 0 1 3.257.139c.474.325.843.778 1.066 1.303.223.526.289 1.103.191 1.664zM5.503 8.575 4.139 7.8a.05.05 0 0 1-.026-.037V4.049c0-.57.166-1.127.476-1.607s.752-.864 1.275-1.105a3.08 3.08 0 0 1 3.234.41l-.096.054-3.23 1.838a.53.53 0 0 0-.265.455zm.742-1.577 1.758-1 1.762 1v2l-1.755 1-1.762-1z"/>
                </svg>
              </div>
              <div class="horizontal-text">
                <h3 class="horizontal-title">{{ service.title }}</h3>
                <p class="horizontal-description">
                  {{ service.shortDescription }}
                </p>
                <ul class="horizontal-features">
                  <li v-for="(feature, idx) in service.cardFeatures" :key="idx">
                    {{ feature }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="horizontal-indicator">
              <span v-if="activeService === service.id">▼ Seleccionado</span>
              <span v-else>⚡ Click para detalles</span>
            </div>
          </div>
        </div>

        <!-- MÓVIL Y TABLETA: Carrusel -->
        <!-- MÓVIL Y TABLETA: Carrusel -->
<div class="services-carousel-mobile">
  <div class="carousel-container">
    <div
      class="carousel-track"
      :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
    >
      <div
        v-for="service in services"
        :key="service.id"
        class="carousel-slide"
        :class="{ active: activeService === service.id }"
        @click="setActiveService(service.id)"
      >
        <div class="carousel-card">
          <!-- CONTENIDO REORGANIZADO -->
          <div class="carousel-header">
            <div class="carousel-icon">
              <svg v-if="service.iconType === 'code'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0"/>
              </svg>
              <svg v-else-if="service.iconType === 'window'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1zM1 13V6h4v8H2a1 1 0 0 1-1-1m5 1V6h9v7a1 1 0 0 1-1 1z"/>
              </svg>
              <svg v-else-if="service.iconType === 'database'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313M13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A5 5 0 0 0 13 5.698M14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A5 5 0 0 0 13 8.698m0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525"/>
              </svg>
              <svg v-else-if="service.iconType === 'ai'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14.949 6.547a3.94 3.94 0 0 0-.348-3.273 4.11 4.11 0 0 0-4.4-1.934A4.1 4.1 0 0 0 8.423.2 4.15 4.15 0 0 0 6.305.086a4.1 4.1 0 0 0-1.891.948 4.04 4.04 0 0 0-1.158 1.753 4.1 4.1 0 0 0-1.563.679A4 4 0 0 0 .554 4.72a3.99 3.99 0 0 0 .502 4.731 3.94 3.94 0 0 0 .346 3.274 4.11 4.11 0 0 0 4.402 1.933c.382.425.852.764 1.377.995.526.231 1.095.35 1.67.346 1.78.002 3.358-1.132 3.901-2.804a4.1 4.1 0 0 0 1.563-.68 4 4 0 0 0 1.14-1.253 3.99 3.99 0 0 0-.506-4.716m-6.097 8.406a3.05 3.05 0 0 1-1.945-.694l.096-.054 3.23-1.838a.53.53 0 0 0 .265-.455v-4.49l1.366.778q.02.011.025.035v3.722c-.003 1.653-1.361 2.992-3.037 2.996m-6.53-2.75a2.95 2.95 0 0 1-.36-2.01l.095.057L5.29 12.09a.53.53 0 0 0 .527 0l3.949-2.246v1.555a.05.05 0 0 1-.022.041L6.473 13.3c-1.454.826-3.311.335-4.15-1.098m-.85-6.94A3.02 3.02 0 0 1 3.07 3.949v3.785a.51.51 0 0 0 .262.451l3.93 2.237-1.366.779a.05.05 0 0 1-.048 0L2.585 9.342a2.98 2.98 0 0 1-1.113-4.094zm11.216 2.571L8.747 5.576l1.362-.776a.05.05 0 0 1 .048 0l3.265 1.86a3 3 0 0 1 1.173 1.207 2.96 2.96 0 0 1-.27 3.2 3.05 3.05 0 0 1-1.36.997V8.279a.52.52 0 0 0-.276-.445m1.36-2.015-.097-.057-3.226-1.855a.53.53 0 0 0-.53 0L6.249 6.153V4.598a.04.04 0 0 1 .019-.04L9.533 2.7a3.07 3.07 0 0 1 3.257.139c.474.325.843.778 1.066 1.303.223.526.289 1.103.191 1.664zM5.503 8.575 4.139 7.8a.05.05 0 0 1-.026-.037V4.049c0-.57.166-1.127.476-1.607s.752-.864 1.275-1.105a3.08 3.08 0 0 1 3.234.41l-.096.054-3.23 1.838a.53.53 0 0 0-.265.455zm.742-1.577 1.758-1 1.762 1v2l-1.755 1-1.762-1z"/>
              </svg>
            </div>
            <h3 class="carousel-title">{{ service.title }}</h3>
          </div>

          <div class="carousel-body">
            <p class="carousel-description">
              {{ service.shortDescription }}
            </p>

            <ul class="carousel-features">
              <li
                v-for="(feature, idx) in service.cardFeatures"
                :key="idx"
              >
                {{ feature }}
              </li>
            </ul>
          </div>

          <div class="carousel-footer">
            <div class="carousel-indicator">
              <span v-if="activeService === service.id"
                >▼ Seleccionado</span
              >
              <span v-else>👆 Toca para detalles</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- INDICADOR DE DESLIZAMIENTO -->
  <div class="carousel-swipe-indicator">
    <div class="swipe-animation">
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path d="M14 7l-5 5 5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span class="swipe-text">Desliza para explorar</span>
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
        <path d="M10 7l5 5-5 5" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="slide-counter">
      {{ currentSlide + 1 }}/{{ services.length }}
    </div>
  </div>
</div>
      </div>

      <!-- SHOWCASE INTEGRADO -->
      <div class="service-showcase-integrated" v-if="activeServiceData">
        <div class="showcase-content">
          <div class="showcase-header">
            <div class="service-badge">
              <svg v-if="activeServiceData.iconType === 'code'" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16">
                <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0"/>
              </svg>
              <svg v-else-if="activeServiceData.iconType === 'window'" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16">
                <path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1zM1 13V6h4v8H2a1 1 0 0 1-1-1m5 1V6h9v7a1 1 0 0 1-1 1z"/>
              </svg>
              <svg v-else-if="activeServiceData.iconType === 'database'" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313M13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A5 5 0 0 0 13 5.698M14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A5 5 0 0 0 13 8.698m0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525"/>
              </svg>
              <svg v-else-if="activeServiceData.iconType === 'ai'" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14.949 6.547a3.94 3.94 0 0 0-.348-3.273 4.11 4.11 0 0 0-4.4-1.934A4.1 4.1 0 0 0 8.423.2 4.15 4.15 0 0 0 6.305.086a4.1 4.1 0 0 0-1.891.948 4.04 4.04 0 0 0-1.158 1.753 4.1 4.1 0 0 0-1.563.679A4 4 0 0 0 .554 4.72a3.99 3.99 0 0 0 .502 4.731 3.94 3.94 0 0 0 .346 3.274 4.11 4.11 0 0 0 4.402 1.933c.382.425.852.764 1.377.995.526.231 1.095.35 1.67.346 1.78.002 3.358-1.132 3.901-2.804a4.1 4.1 0 0 0 1.563-.68 4 4 0 0 0 1.14-1.253 3.99 3.99 0 0 0-.506-4.716m-6.097 8.406a3.05 3.05 0 0 1-1.945-.694l.096-.054 3.23-1.838a.53.53 0 0 0 .265-.455v-4.49l1.366.778q.02.011.025.035v3.722c-.003 1.653-1.361 2.992-3.037 2.996m-6.53-2.75a2.95 2.95 0 0 1-.36-2.01l.095.057L5.29 12.09a.53.53 0 0 0 .527 0l3.949-2.246v1.555a.05.05 0 0 1-.022.041L6.473 13.3c-1.454.826-3.311.335-4.15-1.098m-.85-6.94A3.02 3.02 0 0 1 3.07 3.949v3.785a.51.51 0 0 0 .262.451l3.93 2.237-1.366.779a.05.05 0 0 1-.048 0L2.585 9.342a2.98 2.98 0 0 1-1.113-4.094zm11.216 2.571L8.747 5.576l1.362-.776a.05.05 0 0 1 .048 0l3.265 1.86a3 3 0 0 1 1.173 1.207 2.96 2.96 0 0 1-.27 3.2 3.05 3.05 0 0 1-1.36.997V8.279a.52.52 0 0 0-.276-.445m1.36-2.015-.097-.057-3.226-1.855a.53.53 0 0 0-.53 0L6.249 6.153V4.598a.04.04 0 0 1 .019-.04L9.533 2.7a3.07 3.07 0 0 1 3.257.139c.474.325.843.778 1.066 1.303.223.526.289 1.103.191 1.664zM5.503 8.575 4.139 7.8a.05.05 0 0 1-.026-.037V4.049c0-.57.166-1.127.476-1.607s.752-.864 1.275-1.105a3.08 3.08 0 0 1 3.234.41l-.096.054-3.23 1.838a.53.53 0 0 0-.265.455zm.742-1.577 1.758-1 1.762 1v2l-1.755 1-1.762-1z"/>
              </svg>
            </div>
            <h2 class="service-title">{{ activeServiceData.title }}</h2>
            <p class="service-subtitle">{{ activeServiceData.subtitle }}</p>
          </div>

          <div class="showcase-body">
            <div class="service-description">
              <h3>Descripción del Servicio</h3>
              <p>{{ activeServiceData.description }}</p>
            </div>

            <div class="service-features">
              <h3>¿Qué incluye?</h3>
              <ul class="features-list">
                <li
                  v-for="feature in activeServiceData.features"
                  :key="feature"
                >
                  {{ feature }}
                </li>
              </ul>
            </div>

            <div class="service-technologies">
              <h3>Tecnologías y Herramientas</h3>
              <div class="tech-tags">
                <span
                  v-for="tech in activeServiceData.technologies"
                  :key="tech"
                  class="tech-tag"
                >
                  {{ tech }}
                </span>
              </div>
            </div>

            <div class="service-cta">
              <RouterLink to="/ejemplos" class="btn-examples">
                <span>Ver Ejemplos</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                </svg>
              </RouterLink>
            </div>
          </div>
        </div>
      </div>

      <!-- MENSAJE CUANDO NO HAY SERVICIO SELECCIONADO -->
      <div class="no-service-selected" v-else>
        <div class="selection-prompt">
          <div class="prompt-icon">👆</div>
          <h3>Selecciona un servicio para ver los detalles completos</h3>
          <p>Haz click en cualquiera de las tarjetas para explorar cada servicio a fondo</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* eslint-disable */
import { ref, computed, onMounted } from 'vue';
import { RouterLink } from 'vue-router';

// Estado reactivo
const activeService = ref(null);
const currentSlide = ref(0);

// Datos de los servicios
const services = ref([
  {
    id: 'web-development',
    title: 'Desarrollo de Páginas Web',
    subtitle: 'Presencia digital profesional para tu negocio',
    iconType: 'code',
    description: 'Creación de sitios web modernos, responsivos y optimizados para convertir visitantes en clientes. Desarrollamos desde landing pages hasta portales complejos, siempre con las mejores prácticas de desarrollo.',
    shortDescription: 'Sitios web modernos y responsivos diseñados para convertir visitantes en clientes.',
    features: [
      'Diseño 100% responsivo y adaptable a todos los dispositivos',
      'Optimización SEO para mejor posicionamiento en buscadores',
      'Vinculacion con redes sociales',
      'Panel de administración fácil de usar',
      'Optimización de velocidad y rendimiento',
      'Certificado SSL y seguridad implementada',
    ],
    technologies: ['Vue.js', 'JavaScript', 'HTML5', 'CSS3', 'Bootstrap', 'GitHub', 'Cloudflare'],
    cardFeatures: ['Diseño móvil', 'Optimización SEO', 'Soporte y actualizaciones', 'Alta velocidad'],
  },
  {
    id: 'web-optimization',
    title: 'Optimización de Sitios Webs',
    subtitle: 'Mejora el rendimiento y conversión de tu sitio existente',
    iconType: 'window',
    description: 'Actualización y optimización de sitios web existentes para mejorar su rendimiento, seguridad y conversión. Incluye migración a tecnologías modernas, mejora de velocidad, y actualización de diseño según tendencias actuales.',
    shortDescription: 'Mejora el rendimiento, seguridad y conversión de tu sitio web existente.',
    features: [
      'Compatibilidad entre navegadores',
      'Migración a tecnologías modernas y frameworks actuales',
      'Optimización de velocidad de carga',
      'Mejoras del diseño y usabilidad',
      'Optimización SEO para mejor posicionamiento en buscadores',
      'Experiencia móvil mejorada',
    ],
    technologies: ['Vue.js', 'JavaScript', 'HTML5', 'CSS3', 'Bootstrap', 'GitHub', 'Cloudflare'],
    cardFeatures: ['Tecnología actualizada', 'Mejora de velocidad', 'Actualización diseño', 'Optimización SEO'],
  },
  {
    id: 'automation',
    title: 'Automatización de Procesos',
    subtitle: 'Digitaliza tareas repetitivas y aumenta la eficiencia',
    iconType: 'database',
    description: 'Desarrollo de soluciones personalizadas para automatizar procesos empresariales como contabilidad, gestión de inventario, reportes automáticos y más. Reducimos el trabajo manual y minimizamos errores humanos.',
    shortDescription: 'Soluciones personalizadas para automatizar procesos empresariales repetitivos.',
    features: [
      'Sistema de contabilidad automatizada',
      'Gestión inteligente de inventario',
      'Dashboard de reportes financieros',
      'Automatización de procesos comerciales',
      'Control de caja y flujo de efectivo',
      'Sistema de alertas y notificaciones',
    ],
    technologies: ['Google Sheets', 'Microsoft Access', 'Microsoft Excel', 'Canva', 'Google Forms'],
    cardFeatures: ['Procesos contables', 'Gestión de inventario', 'Reportes automáticos', 'Control de caja'],
  },
  {
    id: 'ai-implementation',
    title: 'Implementación de IAs',
    subtitle: 'Inteligencia Artificial aplicada a tu negocio',
    iconType: 'ai',
    description: 'Asesoría e implementación de soluciones de Inteligencia Artificial para optimizar operaciones,crear contenido y toma de desciciones.',
    shortDescription: 'Soluciones de Inteligencia Artificial para optimizar operaciones y decisiones.',
    features: [
      'Implementación de asistentes de IA empresariales',
      'Automatización inteligente de procesos operativos',
      'Generación de contenido con modelos de IA',
      'Analisis de datos con IA',
      'Optimización de productividad mediante agentes IA',
    ],
    technologies: ['OpenAI GPT', 'Google Gemini', 'Midjourney/DALL-E', 'Chatfuel/ManyChat', 'Zapier/Integromat'],
    cardFeatures: ['Asistentes IA Empresariales', 'Automatización de Procesos', 'Generación de Contenido IA', 'Optimización de Productividad'],
  },
]);

// Computed
const activeServiceData = computed(() => {
  return services.value.find((service) => service.id === activeService.value);
});

// Methods
const setActiveService = (serviceId) => {
  activeService.value = serviceId === activeService.value ? null : serviceId;
};

const goToSlide = (index) => {
  // Lógica para carrusel infinito
  if (index < 0) {
    index = services.value.length - 1;
  } else if (index >= services.value.length) {
    index = 0;
  }

  currentSlide.value = index;
  setActiveService(services.value[index].id);
};

// Animaciones y touch events para carrusel
const setupCarousel = () => {
  const track = document.querySelector('.carousel-track');
  if (!track) return;

  let startX = 0;
  let currentX = 0;
  let isDragging = false;

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
    track.style.transition = 'none';
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
    const diff = startX - currentX;
    track.style.transform = `translateX(calc(-${currentSlide.value * 100}% - ${diff}px))`;
  };

  const handleTouchEnd = (e) => {
    if (!isDragging) return;
    isDragging = false;
    track.style.transition = 'transform 0.3s ease';

    const diff = startX - currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        goToSlide(currentSlide.value + 1);
      } else {
        goToSlide(currentSlide.value - 1);
      }
    }
    track.style.transform = `translateX(-${currentSlide.value * 100}%)`;
  };

  track.addEventListener('touchstart', handleTouchStart);
  track.addEventListener('touchmove', handleTouchMove);
  track.addEventListener('touchend', handleTouchEnd);
};

// Animaciones
onMounted(() => {
  const animateHero = () => {
    const title = document.querySelector('.animate-title');
    const subtitle = document.querySelector('.animate-subtitle');
    const circles = document.querySelectorAll('.circle');

    setTimeout(() => {
      title?.classList.add('animated');
      subtitle?.classList.add('animated');
      circles.forEach((circle, index) => {
        setTimeout(() => {
          circle.classList.add('animated');
        }, index * 200);
      });
    }, 300);
  };

  animateHero();
  setupCarousel();

  // Solo en pantallas menores a 992px: seleccionar primer servicio
  if (window.innerWidth <= 991) {
    activeService.value = services.value[0].id;
  }
});
</script>

<style scoped>
/* HERO DE SERVICIOS */
.services-hero {
  background: linear-gradient(135deg, var(--color-background) 0%, #1a1f2e 100%);
  color: var(--color-text-primary);
  position: relative;
  width: 100%;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 55px !important;
}

.services-hero .hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

/* CÍRCULOS FLOTANTES */
.floating-circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0);
}

.circle-1 {
  width: 120px;
  height: 120px;
  top: 20%;
  left: 10%;
  background: linear-gradient(135deg, #3c27ffe7 0%, #4636dad7 50%, #2d5ee6d7 100%);
  animation: float 6s ease-in-out infinite;
}

.circle-2 {
  width: 80px;
  height: 80px;
  top: 60%;
  right: 15%;
  background: linear-gradient(135deg, #0f96a8 0%, #21c8dfdc 50%, #9dbdff 100%);
  animation: float 8s ease-in-out infinite 1s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  bottom: 10%;
  left: 20%;
  background: linear-gradient(135deg, #3c27ffe7 0%, #4636dad7 50%, #2d5ee6d7 100%);
  animation: float 10s ease-in-out infinite 2s;
}

.circle-4 {
  width: 100px;
  height: 100px;
  top: 30%;
  right: 25%;
  background: linear-gradient(135deg, #0f96a8 0%, #21c8dfdc 50%, #9dbdff 100%);
  animation: float 7s ease-in-out infinite 1.5s;
}

.animate-float-1.animated,
.animate-float-2.animated,
.animate-float-3.animated,
.animate-float-4.animated {
  opacity: 0.4;
  transform: scale(1);
  transition: all 1s ease-out;
}

@keyframes float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.05); }
}

/* SECCIÓN PRINCIPAL */
.all-services-section {
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  min-height: 100vh;
  padding: 80px 20px;
  display: flex;
  align-items: center;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--color-text-primary);
  margin-bottom: 3rem;
}

/* CONTENEDOR PRINCIPAL */
.services-main-container {
  width: 100%;
}

/* DESKTOP: Grid 2x2 Horizontal */
.services-grid-desktop {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-horizontal-card {
  background: var(--color-background);
  border-radius: 16px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.service-horizontal-card:hover {
  transform: translateY(-5px);
  border-color: var(--color-primary);
  box-shadow: 0 10px 30px rgba(92, 141, 246, 0.2);
}

.service-horizontal-card.active {
  border-color: var(--color-primary);
  background: rgba(92, 141, 246, 0.05);
}

.horizontal-card-content {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.horizontal-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 12px;
  flex-shrink: 0;
}

.horizontal-icon svg {
  color: white;
  width: 25px;
  height: 25px;
}

.horizontal-text {
  flex: 1;
}

.horizontal-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.horizontal-description {
  color: var(--color-text-secondary);
  margin-bottom: 1rem;
  line-height: 1.5;
}

.horizontal-features {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.horizontal-features li {
  padding: 0.25rem 0;
  padding-left: 1.2rem;
  position: relative;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

.horizontal-features li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--color-primary);
  font-weight: bold;
}

.horizontal-indicator {
  text-align: center;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.service-horizontal-card.active .horizontal-indicator {
  color: var(--color-primary);
  font-weight: 600;
}

/* CARRUSEL PARA MÓVIL Y TABLETA */
.services-carousel-mobile {
  display: none;
  position: relative;
}

.carousel-container {
  overflow: hidden;
  border-radius: 16px;
  height: 400px;
}

.carousel-track {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
}

.carousel-slide {
  flex: 0 0 100%;
  min-width: 100%;
  height: 400px;
  display: flex;
  align-items: stretch;
}

.carousel-card {
  background: var(--color-background);
  border-radius: 16px;
  padding: 2rem;
  margin: 0 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 350px;
}

.carousel-card.active {
  border-color: var(--color-primary);
  background: rgba(92, 141, 246, 0.05);
}

.carousel-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 12px;
  margin: 0 auto 1rem;
  flex-shrink: 0;
}

.carousel-icon svg {
  color: white;
  width: 25px;
  height: 25px;
}

.carousel-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--color-text-primary);
  margin-bottom: 1rem;
  text-align: center;
  flex-shrink: 0;
}

.carousel-description {
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.5;
  text-align: center;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-features {

  margin-bottom: 1.5rem;
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.carousel-features li {

  color: var(--color-text-secondary);
  font-size: 0.9rem;
  list-style: none;
  padding: 0.6rem 0;
  padding-left:2rem;
  position:relative;
}

.carousel-features li::before {
  content: "✓";
  position: absolute;
  left: 0.7rem;
  right: 0.6rem;

  color: var(--color-primary);
  font-weight: bold;
}

.carousel-indicator {
  text-align: center;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.carousel-card.active .carousel-indicator {
  color: var(--color-primary);
  font-weight: 600;
}

/* INDICADOR DE DESLIZAMIENTO */
.carousel-swipe-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1rem;
  width: 100%;
}

.swipe-animation {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  animation: pulse-swipe 2s infinite;
}

.swipe-text {
  color: var(--color-primary);
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
}

.slide-counter {
  background: rgba(92, 141, 246, 0.1);
  color: var(--color-primary);
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid var(--color-primary);
}

@keyframes pulse-swipe {
  0%, 100% { opacity: 0.7; transform: translateX(0); }
  50% { opacity: 1; transform: translateX(5px); }
}

/* SHOWCASE INTEGRADO */
.service-showcase-integrated {
  background: var(--color-background);
  border-radius: 16px;
  padding: 3rem;
  margin-top: 3rem;
  border: 2px solid var(--color-primary);
  animation: fadeInUp 0.5s ease-out;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.showcase-content {
  max-width: 1000px;
  margin: 0 auto;
}

.showcase-header {
  text-align: center;
  margin-bottom: 3rem;
}

.service-badge {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 50%;
  margin: 0 auto 1.5rem;
}

.service-badge svg {
  color: white;
  width: 35px;
  height: 35px;
}

.service-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
}

.service-subtitle {
  font-size: 1.2rem;
  color: var(--color-text-secondary);
}

.showcase-body {
  display: grid;
  gap: 2.5rem;
}

.service-description h3,
.service-features h3,
.service-technologies h3 {
  font-size: 1.5rem;
  color: var(--color-text-primary);
  margin-bottom: 1rem;
}

.service-description p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: var(--color-text-secondary);
}

.features-list {
  list-style: none;
  padding: 0;
}

.features-list li {
  padding: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
  color: var(--color-text-secondary);
}

.features-list li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--color-primary);
  font-weight: bold;
}

.tech-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tech-tag {
  background: rgba(92, 141, 246, 0.1);
  color: var(--color-primary);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  border: 1px solid var(--color-primary);
}

.service-cta {
  text-align: center;
  margin-top: 2rem;
}

.btn-examples {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--color-primary);
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.btn-examples:hover {
  background: #0a58ca;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(92, 141, 246, 0.4);
}

/* MENSAJE DE SELECCIÓN */
.no-service-selected {
  text-align: center;
  padding: 4rem 2rem;
  background: var(--color-background);
  border-radius: 16px;
  border: 2px dashed rgba(92, 141, 246, 0.3);
  margin-top: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.selection-prompt .prompt-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.selection-prompt h3 {
  color: var(--color-text-primary);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.selection-prompt p {
  color: var(--color-text-secondary);
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ANIMACIONES */
.animate-title,
.animate-subtitle {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease-out;
}

.animate-title.animated,
.animate-subtitle.animated {
  opacity: 1;
  transform: translateY(0);
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* RESPONSIVE BREAKPOINTS */
/* DESKTOP: ≥ 992px - Grid 2x2 */
@media (min-width: 992px) {
  .services-grid-desktop { display: grid; }
  .services-carousel-mobile { display: none; }
}

/* TABLETA Y MÓVIL: < 992px - Carrusel */
@media (max-width: 991px) {
  .services-grid-desktop { display: none; }
  .services-carousel-mobile { display: block; }
}

/* TABLETA: 771px - 991px */
@media (min-width: 771px) and (max-width: 991px) {
  .carousel-container {
    height: 420px;
    max-width: 600px;
    margin: 0 auto;
  }

  .carousel-slide { height: 420px; }

  .carousel-card {
    padding: 2.2rem;
    margin: 0 1.5rem;
    min-height: 380px;
  }

  .carousel-title { font-size: 1.5rem; }
  .carousel-description { font-size: 1.05rem; }
  .carousel-features li { font-size: 0.95rem; padding: 0.6rem 0; }

  .carousel-swipe-indicator { margin-top: 2.5rem; }
  .swipe-text { font-size: 1rem; }
  .swipe-animation svg { width: 35px; height: 35px; }
}

/* MÓVIL MEDIANO: 481px - 770px */
@media (min-width: 481px) and (max-width: 770px) {
  .carousel-container { height: 380px; }
  .carousel-slide { height: 380px; }
  .carousel-card {
    padding: 1.8rem;
    margin: 0 1rem;
    min-height: 340px;
  }
}

/* MÓVIL PEQUEÑO: ≤ 480px */
@media (max-width: 480px) {
  .services-hero {
    height: 100vh;
  }

  .services-hero .display-3 {
    font-size: 1.8rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .carousel-container { height: 360px; }
  .carousel-slide { height: 360px; }
  .carousel-card {
    padding: 1.25rem;
    margin: 0 0.5rem;
    min-height: 300px;
  }

  .carousel-title { font-size: 1.2rem; }
  .carousel-description { font-size: 0.9rem; }
  .carousel-features li { font-size: 0.85rem; padding: 0.4rem 0; }

  .service-showcase-integrated {
    padding: 2rem 1.5rem;
    margin-top: 2rem;
  }

  .service-title { font-size: 1.8rem; }

  .no-service-selected {
    margin-top: 2rem;
    padding: 3rem 1.5rem;
    min-height: 250px;
  }

  .selection-prompt h3 { font-size: 1.2rem; }
  .selection-prompt p { font-size: 0.9rem; }
}

/* ELIMINAR SCROLL HORIZONTAL */
.services-hero,
.all-services-section,
.services-main-container,
.services-carousel-mobile,
.carousel-container {
  overflow-x: hidden !important;
  max-width: 100vw;
}

body {
  overflow-x: hidden;
}




/* CARRUSEL REORGANIZADO */
.carousel-card {
  background: var(--color-background);
  border-radius: 16px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 350px;
}

.carousel-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
}

.carousel-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 12px;
  flex-shrink: 0;
}

.carousel-icon svg {
  color: white;
  width: 25px;
  height: 25px;
}

.carousel-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--color-text-primary);
  text-align: center;
  margin: 0;
}

.carousel-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.carousel-description {
  color: var(--color-text-secondary);
  line-height: 1.5;
  text-align: center;
  margin: 0;
  font-size: 0.95rem;
}

.carousel-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}

.carousel-features li {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  padding: 0.5rem 0;
  padding-left: 1.8rem;
  position: relative;
  line-height: 1.4;
}

.carousel-features li::before {
  content: "✓";
  position: absolute;
  left: 0.7rem;
  color: var(--color-primary);
  font-weight: bold;
}

.carousel-footer {
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
}

.carousel-indicator {
  text-align: center;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
}

.carousel-card.active .carousel-indicator {
  color: var(--color-primary);
  font-weight: 600;
}

/* RESPONSIVE ADJUSTMENTS */
@media (max-width: 480px) {
  .carousel-card {
    padding: 1.25rem;
    min-height: 320px;
  }

  .carousel-header {
    gap: 0.8rem;
    margin-bottom: 1rem;
  }

  .carousel-icon {
    width: 50px;
    height: 50px;
  }

  .carousel-icon svg {
    width: 20px;
    height: 20px;
  }

  .carousel-title {
    font-size: 1.2rem;
  }

  .carousel-body {
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .carousel-description {
    font-size: 0.9rem;
  }

  .carousel-features li {
    font-size: 0.85rem;
    padding: 0.4rem 0;
    padding-left: 1.5rem;
  }

  .carousel-features li::before {
    left: 0.5rem;
  }
}

@media (min-width: 481px) and (max-width: 770px) {
  .carousel-card {
    padding: 1.8rem;
    min-height: 380px;
  }

  .carousel-features {
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
  }
}
</style>
